import dynamicImport from 'components/dynamicImport';
import { observer, inject } from 'mobx-react';
import React, { Component } from 'react';
import Default from './BuyerAgentInviteSection';
import AgentInviteStore from './stores';

const Content = dynamicImport({
  component: '/containers/Sale/BuyerAgentInviteSection',
  fallback: Default,
});

@inject('app', 'sale')
@observer
class BuyerAgentInviteSection extends Component {
  constructor(props) {
    super(props);
    this.agent = new AgentInviteStore(props.sale);
  }

  render() {
    return <Content {...this.props} agent={this.agent} />;
  }
}

export default BuyerAgentInviteSection;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/BuyerAgentInviteSection/index.js